import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { PolicyDocument, PolicyId } from '@estercare/ester-shared'
import { QueryKeys } from '../../types'
import { getPolicyDocument } from './policies'

export const useGetPolicyDocument = ({
  policyId,
  language,
  version,
}: {
  policyId: PolicyId
  language: string
  version?: string
}): UseQueryResult<PolicyDocument, Error> => {
  return useQuery({
    queryKey: [QueryKeys.Policy, policyId, language, version ?? 'current', 'public'],
    queryFn: () => getPolicyDocument({ policyId, language, version }),
    retry: false,
  })
}
